import { BaseQueryFn, FetchArgs, createApi } from '@reduxjs/toolkit/dist/query/react';
import { eLocalStorageTags } from './eLocalStorageTags';
import { ePersonalizationKeys } from './personalization/ePersonalizationKeys';

const getLocalStorage = ({ url }: { url: string }) => {
  const stringData = localStorage.getItem(url);
  const data = (stringData && JSON.parse(stringData)) ?? undefined;
  if (!data) {
    return { error: { message: 'No Data Yet, no action is required' } };
  }
  return { data };
};

const putLocalStorage = ({ url, body }: { url: string; body: any }) => {
  const stringBody = JSON.stringify(body);
  localStorage.setItem(url, stringBody);
  return { data: body };
};

const localStorageBaseQuery: BaseQueryFn<FetchArgs, string[], { message: string }> = async ({ url, method, body }) => {
  switch (method) {
    case 'GET':
      return getLocalStorage({ url });
    case 'PUT':
      return putLocalStorage({ url, body });
  }
  return { error: { message: 'Unsupported Method, use get or put with local storage apis.' } };
};

const tagTypes = [...Object.values(eLocalStorageTags), ...Object.values(ePersonalizationKeys)];

export const LocalStorageAPI = createApi({
  reducerPath: 'localStorageApi',
  baseQuery: localStorageBaseQuery,
  tagTypes,
  endpoints: (build) => ({}),
});
